var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 80.5C37.25 80.5 35 78.25 35 75.5V5.5C35 2.75 37.25 0.5 40 0.5C42.75 0.5 45 2.75 45 5.5V75.5C45 78.25 42.75 80.5 40 80.5Z",
    fill: "#20262D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45.5H5C2.25 45.5 0 43.25 0 40.5C0 37.75 2.25 35.5 5 35.5H75C77.75 35.5 80 37.75 80 40.5C80 43.25 77.75 45.5 75 45.5Z",
    fill: "#20262D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.edbcdb318bde5bddc857adabcf713e6f.svg";
export { ForwardRef as ReactComponent };